import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {PatientService} from '../../modules/patient/patient.service';
import {PatientSearchModel} from '../../models/patient/patient-search.model';
import {MatOptionSelectionChange} from '@angular/material/core';
import {MessagingConstants} from '../../models/MessagingConstants';
import {Globals} from '../../globals';
import {MessagingService} from '../../services/messaging.service';
import {CommMethodEnum} from '../../models/enum/comm-method.enum';
import { FormatPhonePipe } from 'src/app/pipes/format-phone.pipe';
import {UiService} from '../../services/ui.service';



@Component({
  selector: 'tdo-patient-search',
  templateUrl: './tdo-patient-search.component.html',
  styleUrls: ['./tdo-patient-search.component.scss']
})
export class TdoPatientSearchComponent implements OnInit {
  @ViewChild('inp') input: ElementRef;

  @Input() isChangeUser: boolean = true;
  @Input() disabled: boolean = false;
  @Input() displayWith: ((value: any) => string) | null;

  @Output() patientSelect: EventEmitter<PatientSearchModel> = new EventEmitter<PatientSearchModel>();

  searchString = '';
  patientSearchList: PatientSearchModel[] = [];
  patientSearchListLength =0;

  constructor(private patientService: PatientService,
              private globals: Globals,
              private messagingService: MessagingService,
              private uiService: UiService,
              private formatPhonePipe: FormatPhonePipe) { }

  ngOnInit(): void {
  }

  focus() {
    this.input?.nativeElement?.focus();
  }

  onPatientSearchInput(event: string) {
    this.patientService.patientSearch(event).subscribe((res) => {
      if (res.SearchInput === this.searchString) {
        this.patientSearchList = res.SearchResults;
        this.patientSearchListLength = this.patientSearchList.length;
      }
    });
  }


  //onPatientSearchAutoComplete($event: MatOptionSelectionChange, patient: PatientSearchModel) {
  onPatientSearchAutoComplete(zevent: any, patient: PatientSearchModel) {

    if(!zevent.isUserInput) {
      return;
    }

    if (this.isChangeUser) {

      //this.globals.currentPatientId = patient.PatientId;
      this.messagingService.broadCastMessage(MessagingConstants.PATIENT_CHANGED, {
        PatientID: patient.PatientId,
        clearCurrentQuery: false
      });

    }

    //this.uiService.handlePatientSwitchImagingWindow();

    this.patientSelect.emit(patient);


  }

  formatContact(contact: string){

  }

  getInputType(user: PatientSearchModel) {
    if (user.ContactMethod === CommMethodEnum.Mobile || user.ContactMethod === CommMethodEnum.Phone) {
      return 'phone';
    }

    if (user.ContactMethod === CommMethodEnum.Email) {
      return 'email';
    }

    return '';
  }

  clear() {
    this.searchString = '';
  }
}
